<div class="root flex-col">
  <app-navigation></app-navigation>
  <div class="page-holder">
    <router-outlet></router-outlet>
  </div>
</div>

<ngx-spinner></ngx-spinner>
